import { Outlet } from "react-router-dom";
import PublicHeader from "./PublicHeader";
import PublicFooter from "./PublicFooter";

const PublicLayout: React.FC = () => {
    return (
        <div className="min-h-screen flex flex-col bg-gradient-to-br from-brand-25 via-yellow-25 to-lavender-25 dark:bg-gray-900">
            <PublicHeader />
            <main className="flex-1">
                <Outlet />
            </main>
            <PublicFooter />
        </div>
    );
};

export default PublicLayout;
